
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Comp_Fix","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"TOP","transform":"translate(-291 -4344)","fill":"currentColor"}},[_c('g',{attrs:{"id":"pager","transform":"translate(0 4324)"}},[_c('g',{attrs:{"id":"icon_last","transform":"translate(285 15)"}},[_c('path',{attrs:{"d":"M7.413 5h.002l5.656 5.656 1.414 1.414-7.071 7.072L6 17.728l5.657-5.658L6 6.414 7.413 5zm5 0h.002l5.656 5.656 1.414 1.414-7.071 7.072L11 17.728l5.657-5.658L11 6.414 12.413 5z","id":"Fill-2"}})])])])])])
          )
        }
      }
    